export default "__VITE_ASSET__ZS8VbKLn__"